import { useInjection } from 'inversify-react';

import { Slider } from '@desygner/ui-common-components';

import { VideoManager } from '../../../../../core/viewer/video-manager';
import { TYPES } from '../../../../../inversify.types';
import { IViewerStoreInjector } from '../../../../../store';
import { StyledFullWidthSlider, StyledProgressSliderWrapper } from './ProgressSlider.styles';
import { Timestamp } from './Timestamp';

export const ProgressSlider = () => {
  const videoManager = useInjection<VideoManager>(TYPES.Viewer.VideoManager);
  const useViewerStore = useInjection<IViewerStoreInjector>(TYPES.Store.Viewer);
  const currentPlayingMedia = useViewerStore((state) => state.currentPlayingMedia);

  const currentTime = Math.round(currentPlayingMedia?.currentTime ?? 0);

  function handleSeek(value: number) {
    if (!videoManager.currentActiveVideo) return;

    videoManager.currentActiveVideo.currentTime = value;

    const currentState = currentPlayingMedia;

    if (currentState) {
      useViewerStore.getState().setCurrentPlayingMedia({
        ...currentState,
        currentTime: value,
      });
    }
  }

  if (!currentPlayingMedia) return null;

  return (
    <StyledProgressSliderWrapper>
      <Timestamp currentTime={currentTime} />
      <StyledFullWidthSlider>
        <Slider
          data-testid="video-progress-slider"
          step={1}
          value={currentTime}
          onChange={handleSeek}
          min={0}
          max={Math.floor(Number(currentPlayingMedia.totalDuration))}
        />
      </StyledFullWidthSlider>
    </StyledProgressSliderWrapper>
  );
};
